<div class="dots" [ngClass]="direction"></div>
